import * as R from 'ramda';
import { sortStringsAphabetically } from './sortStringsAphabetically';
import { sortAccessScopesByPriority } from './sortAccessScopesByPriority';

export const removeRedundantAccessScopes = (accessScopes: string[]): string[] => {
  const prioritizedAccessScopes = sortAccessScopesByPriority(accessScopes, true);
  const uniqueAccessScopes = R.uniqBy(
    (accessScope: string) => accessScope.substr(0, accessScope.length - 2),
    prioritizedAccessScopes,
  );

  return sortStringsAphabetically(uniqueAccessScopes);
};
